export default function AIChildCare() {
    return (
        <div className="mt-14 py-4">
            <div className="max-w-7xl mx-auto px-12 sm:px-4">
                {/* Header Section */}
                <header className="text-center">
                    <h1 className="text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
                        AI Child Care – Child Counselling Podcasts for Parents
                    </h1>
                    <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
                        Support parents while growing your school's reach with our AI-powered Child Counselling Podcasts. Covering 15+ crucial parenting topics—from stress management, anxiety, and exam handling to mental health, positive mindset, and everyday challenges children face—these podcasts provide expert guidance parents can trust.
                    </p>
                </header>
                {/* Main Content Section */}
                <div className="mt-8 md:mt-12 sm:mt-8 grid grid-cols-2 md:grid-cols-1 gap-8 md:gap-6 sm:gap-4 items-start mb-12 md:mb-8 sm:mb-6">
                    {/* Left Side */}
                    <aside aria-label="Key features" className="self-center space-y-6 md:space-y-5 sm:space-y-4">
                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Comprehensive Parenting Support</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">Podcasts address critical parenting issues and are constantly updated based on parent feedback.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                </svg>
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Voice & Video Formats</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">Delivered as engaging audio and video content for easy consumption anytime.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Branded for Your School</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">All content is created in the school's name, reinforcing your brand and enhancing visibility.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                </svg>
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Lead Generation & Social Reach</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">Parents are encouraged to share the podcasts with other parents, including unregistered ones, expanding your social media presence and attracting prospective admissions.</p>
                                </div>
                            </div>
                        </section>
                    </aside>
                    {/* Right Side - Benefits */}
                    <div className="flex justify-center">
                        <img
                            src="/images/new-landing-page/aiChildCareFirstImage.svg"
                            alt="Inspire 365 Dashboard showing Today's Lessons and Students"
                            className="w-[80%]"
                        />
                    </div>
                </div>
                {/* Bottom Text */}
                <div className="text-center">
                    <p className="text-sm sm:text-xs text-gray-700 max-w-6xl mx-auto leading-relaxed px-4">
                        AI Child Care podcasts empower parents, strengthen school-parent relationships, and act as a powerful marketing and lead-generation tool, boosting engagement, visibility, and trust in your school.
                    </p>
                </div>
            </div>
        </div>
    );
}